var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonOnCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_772_889)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.7138 21.7C41.6316 21.4036 41.4331 21.1627 41.1503 21.0145C41.211 20.3498 41.1209 19.5349 40.9675 18.8624C40.8323 18.3114 40.626 17.6949 40.3081 17.0486C39.9744 16.4159 39.5617 15.7382 38.9819 15.1165C38.4315 14.4702 37.7218 13.8852 36.9194 13.3667C29.9357 8.93732 20.2919 14.1764 21.0409 21.0171C20.7602 21.1627 20.5617 21.4062 20.4826 21.7C18.8281 21.7294 17.4988 22.9576 17.4988 24.4743C17.4988 25.9916 18.8281 27.2225 20.4826 27.2518C20.6119 27.731 21.065 28.0935 21.6285 28.0935C22.2984 28.0935 22.8384 27.5985 22.8384 26.9868V21.9651C22.8384 21.6157 22.653 21.3188 22.3806 21.115C22.6823 19.3866 23.58 17.5598 24.8397 16.4269C26.6906 14.6237 29.9017 13.5809 33.4302 14.367C34.7857 14.7724 36.1228 15.4528 37.2373 16.5406C38.476 17.6551 39.4821 19.3254 39.8105 21.1176C39.0956 21.6471 39.3522 22.1054 39.3522 26.9868C39.3522 27.3681 39.5774 27.6912 39.9006 27.8897V28.3134C39.9006 28.5832 39.8236 28.8482 39.678 29.0755C38.0978 31.535 37.9947 31.7864 35.609 32.549C34.86 32.7899 34.0126 32.8931 33.1552 33.1021C32.3691 32.3212 30.9738 32.835 30.9738 33.8804C30.9738 35.196 33.0306 35.4982 33.4302 34.1794C34.0074 34.0396 34.6034 33.9574 35.1643 33.785C38.2408 32.8507 39.2464 32.295 40.8748 29.187C41.0282 28.8927 41.1105 28.5674 41.1105 28.2338V27.9583C41.4121 27.8153 41.629 27.5613 41.7138 27.2518C43.3631 27.2198 44.6924 25.9916 44.6924 24.4743C44.6924 22.9602 43.3631 21.732 41.7138 21.7Z",
    fill: "#F9DEB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1006 39.6529C32.0884 38.266 32.9458 37.0745 33.7906 35.8699C34.7779 34.4615 35.7735 34.0064 37.3327 34.5333C39.3156 35.2031 41.2797 35.9495 43.1966 36.7833C44.8459 37.5034 45.7724 38.7845 45.6692 40.6852C45.6163 41.6227 45.6692 42.5623 45.6556 43.4993C45.6216 46.0835 44.4458 47.285 41.8862 47.2986C38.5824 47.3169 35.2786 47.3039 31.9742 47.3039C28.1331 47.3039 24.2945 47.3143 20.4533 47.2986C17.7083 47.2881 16.5514 46.1149 16.5351 43.3831C16.5299 42.4911 16.5802 41.5934 16.5247 40.7041C16.4032 38.7264 17.4224 37.4532 19.1031 36.7278C21.0226 35.8992 22.9977 35.1764 24.9827 34.5196C26.677 33.9561 27.2013 34.2075 28.2499 35.6766C29.1523 36.942 30.0605 38.2048 31.1006 39.6529Z",
    fill: "#F9DEB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0979 23.1641C37.9177 25.4938 37.1819 28.475 34.738 30.7674C32.6656 32.7105 29.5047 32.7608 27.4663 30.77C24.6386 28.0088 23.7493 24.5013 24.1861 20.7156C24.4165 18.7327 25.6238 17.1735 27.6538 16.5089C30.6696 15.5216 33.5895 15.4263 36.2475 17.5333C37.7983 18.7647 38.1534 20.4537 38.0979 23.1641Z",
    fill: "#F9DEB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0955 54.2995C18.1583 54.2995 7.67235 43.8135 7.67235 30.8758C7.67235 17.9387 18.1583 7.45269 31.0955 7.45269C44.0331 7.45269 54.5191 17.9387 54.5191 30.8758C54.5191 43.8135 44.0331 54.2995 31.0955 54.2995ZM31.0955 5.46191C17.0595 5.46191 5.68158 16.8398 5.68158 30.8758C5.68158 44.9123 17.0595 56.2902 31.0955 56.2902C45.132 56.2902 56.5099 44.9123 56.5099 30.8758C56.5099 16.8398 45.132 5.46191 31.0955 5.46191Z",
    fill: "#F9DEB1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_772_889",
    x: -0.0760036,
    y: -0.46199,
    width: 62.8129,
    height: 62.8127,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.73099
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.831373 0 0 0 0 0.596078 0 0 0 0 0.196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_772_889"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.73099
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.831373 0 0 0 0 0.596078 0 0 0 0 0.196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_772_889",
    result: "effect2_dropShadow_772_889"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_772_889",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonOnCall);
export default __webpack_public_path__ + "static/media/person_on_call.83e584b04bfa419bfecbd67d7157eb0c.svg";
export { ForwardRef as ReactComponent };